export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('vue:error', (err) => {
        if (import.meta.server) console.error('[VUE SERVER]', err.message);
        if (import.meta.client) $fetch('/api/error', {params: {error: err.message}}).finally();
    });
});
